module.exports = __webpack_public_path__ + "086fc9f303ff4d07ac669044bbc11c10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-fire.png
// module id = 2094
// module chunks = 4